import { SelectFormField, SelectOption } from 'components/Forms/FormFields';
import { useFormContext } from 'contexts/formContext';
import { CurrentValuesSelected } from '../CurrentValuesSelected/CurrentValuesSelected';
import { FilterStyleBase } from '../MethodsForFilters/FilterStyleBase';
import { Grid } from '@mui/material';
import { BankAccountApprovalType } from 'services/approvals/approvals';
import { sendSubmitEvent } from 'contexts/apiRequestContext';

type BankAccountApprovalsFiltersProps = {
    currentValues: any;
    removeFilterSelected: (index: number) => void;
    approvalType: BankAccountApprovalType;
};


type BankAccountApprovalsFiltersFormProps = {
    approvalType: BankAccountApprovalType
};

export const selectOptionsYesOrNo: SelectOption[] = [
    { label: "Sim", value: 'true' },
    { label: "Não", value: 'false' }
]

function BankAccountApprovalsFiltersForm({ approvalType }: BankAccountApprovalsFiltersFormProps) {
    const { watch } = useFormContext();
    const optionFilterValue = watch('optionFilter');

    function getOptionsFilter() {
        const defaultOptions: SelectOption[] = [
            { label: "Visualizar só os meus", value: 'filterOnlyMine' },
            { label: "Visualizar apenas aprovados", value: 'filterAlreadyApproved' }
        ];

        return defaultOptions;
    }

    return (
        <>
            <SelectFormField
                name="optionFilter"
                label="Filtrar por"
                variant="outlined"
                fullWidth
                options={getOptionsFilter()}
            />

            {optionFilterValue === 'filterOnlyMine' && (
                <SelectFormField
                    label="Escolher se deseja visualizar apenas os meus"
                    variant="outlined"
                    name="filterOnlyMine"
                    fullWidth
                    required
                    options={selectOptionsYesOrNo}
                    showEndAdornment={true}
                    onClick={sendSubmitEvent}
                />
            )}
            {optionFilterValue === 'filterAlreadyApproved' && (
                <SelectFormField
                    label="Apenas aprovados"
                    variant="outlined"
                    name="filterAlreadyApproved"
                    fullWidth
                    required
                    options={selectOptionsYesOrNo}
                    showEndAdornment={true}
                    onClick={sendSubmitEvent}
                />
            )}

        </>
    );
}

export const BankAccountApprovalsFilters = ({
    currentValues,
    removeFilterSelected,
    approvalType
}: BankAccountApprovalsFiltersProps) => {
    const { reset, watch } = useFormContext();
    const optionFilterValue = watch('optionFilter');

    const handleRemoveFilter = (index: number) => {
        removeFilterSelected(index);
        if (optionFilterValue === 'filterOnlyMine') {
            reset({
                optionFilter: 'filterOnlyMine',
                filterOnlyMine: 'false'
            });
        } else {
            reset({
                optionFilter: 'filterAlreadyApproved',
                filterAlreadyApproved: 'true'
            });
        }
    };

    return (
        <Grid mb={2}>
            <FilterStyleBase
                formFilters={<BankAccountApprovalsFiltersForm approvalType={approvalType} />}
                currentValues={
                    <CurrentValuesSelected
                        recordType={`bank-account-approvals-${approvalType}`}
                        currentValues={currentValues}
                        removeFilterSelected={handleRemoveFilter}
                    />
                }
            />
        </Grid>
    );
};
